import { initRichTextEditor } from "./initRichTextEditor";

export const richTextEditor = {
    initRichTextEditor
};
